import React, { useEffect } from 'react';

const GarantiaGloomisUS = () => {
    useEffect(() => {
        document.title = "G. Loomis Warranty | Shimano";
    }, []);

    return (
        <section className="garantia-gloomis container" style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
            <div className="sect-header">
                <div className="sect-titulo">
                    <h1 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '24px' }}>G. Loomis Product Registration</h1>
                </div>
            </div>

            <div className="contenido-garantia">
                <h3 style={{ marginBottom: '20px', fontSize: '16px' }}>Welcome to the G. Loomis family!</h3>
                
                <p style={{ marginBottom: '15px', lineHeight: '1.6', fontSize: '12px' }}>
                    We exist to heighten your enjoyment on the water. It's what we're all about. For you, we build fishing tools that expand tactical opportunity, boost effectiveness, and enhance natural ability. That said, our pledge to provide superior customer experiences applies even when your lines are dry.
                </p>
                
                <p style={{ marginBottom: '25px', lineHeight: '1.6', fontSize: '12px' }}>
                    Please complete the form below to register your rod within 30 days of purchase. Doing so unlocks access to our comprehensive Xpeditor replacement program and other warranty options should you require support in the future.
                </p>

                <p style={{ marginBottom: '40px', lineHeight: '1.6', fontSize: '12px' }}>
                    To register your product, simply {' '}
                    <a 
                        href="/gloomis-registro-producto"
                        style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#0054A6', fontSize: '12px' }}
                    >
                        click here
                    </a> 
                    {' '} and follow the instructions below.
                </p>

                {/* Product Registration Help Section */}
                <div className="ayuda-registro" style={{ marginTop: '40px', borderTop: '1px solid #eee', paddingTop: '30px' }}>
                    <h4 style={{ marginBottom: '25px', fontWeight: 'bold', fontSize: '14px' }}>Product Registration Help</h4>
                    
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', textAlign: 'center' }}>
                        {/* Item 1: Serial Number */}
                        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px', padding: '0 10px' }}>
                            <div style={{ 
                                backgroundColor: '#f8f8f8', 
                                padding: '20px', 
                                borderRadius: '8px',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#333', fontSize: '13px' }}>Serial Number</h5>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                    Locate the serial number on your rod. The serial number will consist of 2 letters, followed by 5 digits.
                                </p>
                                <img 
                                    src="/img/gl.SerialNumber.webp" 
                                    alt="Serial Number"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>

                        {/* Item 2: Model Number */}
                        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px', padding: '0 10px' }}>
                            <div style={{ 
                                backgroundColor: '#f8f8f8', 
                                padding: '20px', 
                                borderRadius: '8px',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#333', fontSize: '13px' }}>Model Number</h5>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                    Located on the tag.
                                </p>
                                <img 
                                    src="/img/model_number.webp" 
                                    alt="Model Number"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>

                        {/* Item 3: Born on Date */}
                        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px', padding: '0 10px' }}>
                            <div style={{ 
                                backgroundColor: '#f8f8f8', 
                                padding: '20px', 
                                borderRadius: '8px',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#333', fontSize: '13px' }}>Born on Date</h5>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                    Printed on the rod.
                                </p>
                                <img 
                                    src="/img/BORN_ON_DATE.webp" 
                                    alt="Born on Date"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>
                    </div>
                    
                    {/* Footer Note: Customer Account */}
                    <p style={{ 
                        marginTop: '30px', 
                        fontSize: '12px', 
                        fontStyle: 'italic', 
                        color: '#666',
                        backgroundColor: '#f9f9f9',
                        padding: '15px',
                        borderRadius: '5px'
                    }}>
                        
                    </p>
                </div>
            </div>
        </section>
    );
};

export default GarantiaGloomisUS;